"use strict";
/* globals module */
/**
 * @module commerceCountryClient
 * @description  Commerce Country Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryClient` uses `commerceCountryRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CommerceLookupsCountryClient = /** @class */ (function () {
    function CommerceLookupsCountryClient(commerceLookupsCountryRoute, commerceLookupsCountryBatchClient, apiClient) {
        this.commerceLookupsCountryRoute = commerceLookupsCountryRoute;
        this.commerceLookupsCountryBatchClient = commerceLookupsCountryBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsCountryClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCountryBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsCountryClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceLookupsCountryClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsCountryClient.get('<country-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCountryClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsCountryRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsCountryClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicCommerceCountryRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCountry is a resource previously fetched using get action.
                        commerceCountry.phoneCode = '<phone-code>';
                        commerceLookupsCountryClient.update(commerceCountry)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsCountryClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountry);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCountry is a resource previously fetched using get action.
                    commerceLookupsCountryClient.remove(commerceCountry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCountryClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsCountryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCountryBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryRoute !== "undefined" && __1.CommerceLookupsCountryRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsCountryBatchClient !== "undefined" && __1.CommerceLookupsCountryBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsCountryClient);
    return CommerceLookupsCountryClient;
}());
exports.CommerceLookupsCountryClient = CommerceLookupsCountryClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
